module.exports = __webpack_public_path__ + "static/media/ARB SB_white.55c211ad.svg";